var a = { icon: { tag: "svg", attrs: { viewBox: "0 0 16 16", focusable: "false", fill: "currentColor" }, children: [{ tag: "path", attrs: { d: "M7 7V1a1 1 0 012 0v6h6a1 1 0 110 2H9v6a1 1 0 11-2 0V9H1a1 1 0 010-2h6z", "fill-rule": "nonzero" } }] }, name: "plus", theme: "outlined" };
export {
  a as default
};
